<template>
  <div class="mdgridviewpage-bg mainWrap-bg applicationListPage indicatorPage" >
    <div class="container-fluid maindivWrap pt-4">
      <div class="row">
        <div class="col-sm-12">
          <div class="row mx-0">
              <div class="col-4 px-0">
                <div v-if="allAlertList.length > 0">
                  <form>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fa fa-search" aria-hidden="true"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search..."
                        id
                        name
                        v-model="searchName"
                        style="border-left:0;"
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-8 px-0">
                <div class="d-flex" style="justify-content: flex-end;">
                  <div class="mx-2">
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="5"
                      label-cols-lg="5"
                      label="Show"
                      label-for="input-horizontal"
                      class="text-rightmr-5"
                    >
                      <b-form-select
                        v-model="perPage"
                        :options="options"
                        size="sm"
                        class
                        label="Show"
                        id="input-horizontal"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="listingTable mb-4">
            <div class="row mx-0">
              <div class="col-12 px-0">
                <div class="row">
                  <div class="col-6">
                    <h5 class="section_title mt-3">Alert</h5>
                  </div>
                  <div class="col-6">
                    <!-- <a href="javascript:void(0)" class="btn btn-sm float-right addTemp_btn mt-3 mr-0" @click="showForm('reset')" > -->
                      <a href="javascript:void(0)" class="btn btn-sm float-right addTemp_btn mt-3 mr-0" @click="showForm('reset')" >
                    <span class="border_bottom_grey">
                      <i class="fa fa-plus" aria-hidden="true"></i> Add Alert
                    </span>
                    </a>
                  </div>
                </div>
                <div class="card tableCard">
                  <div class="card-body px-0 pt-2">
                    <table class="table table-striped table-hover mb-0 bg-white" style="border-radius: 10px; box-shadow: 0px 0px 2px #ddd;" >
                      <thead>
                        <tr class="row mx-0" style="border-radius: 10px 10px 0 0;">
                          <th class="col-4" style="border-top: 0">Indicator Name</th>
                          <th class="col-6" style="border-top: 0">Alert Name</th>
                          <th class="col-2" style="border-top: 0">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="alertList.length > 0">
                          <tr class="row mx-0" v-for="(alert, ind) in alertList" :key="ind">
                            <td class="col-4">{{ alert.targetIndicatorName }}</td>
                            <td class="col-6">{{ alert.alertName }}</td>
                            <td class="col-2">
                              <div class="iconGroup">
                                <a href="#add_indicator" @click="editAlert(alert.alertID)">
                                  <i class="fa fa-pencil-square-o cursor-pointer" aria-hidden="true" v-b-tooltip.hover title="Edit" ></i>
                                </a>
                                <i class="fa fa-trash cursor-pointer" aria-hidden="true" v-b-tooltip.hover title="Delete" @click="deleteAlert(alert.alertID)" ></i>
                              </div>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr class="row mx-0 text-center">
                            <td class="col-12">
                              No Alerts Found!
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="mt-3" v-if="alertList.length > 0">
                  <b-pagination v-model="currentPage" :total-rows="outlierListLen" :per-page="perPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" align="center" ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12" v-if="showAlertForm" ref="outlierAdd">
          <div class="wizardCard mb-4" >
            <div class="card shadow-sm">
              <div class="card-header">Add Outlier/Alert</div>
              <div class="card-body">
                <div class="row m-0 mb-3">
                  <label for="indicatorName" class="col-sm-3 col-form-label" >Alert Name</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" id="indicatorName" placeholder v-model="frmModel.alertName" />
                  </div>
                </div>
                <div class="row m-0 mb-3">
                  <label for="indicatorDesc" class="col-sm-3 col-form-label" >Description</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" id="indicatorDesc" placeholder v-model="frmModel.alertDesc" />
                  </div>
                </div>
                <div class="row m-0 mb-3">
                  <label for="indicatorTypeName" class="col-sm-3 col-form-label" >Data Type</label>
                    <div class="col-sm-9">
                      <div class="">
                        <treeselect :options="sourceList" v-model="frmModel.dataSource" @input="getDataSourceGroup('outer')" placeholder="Search..." />
                      </div>
                    </div>
                </div>
                <template v-if="frmModel.dataSource && dataSourceGroupList.length > 0">
                  <div class="row m-0 mb-3">
                    <label for="indicatorGroup" class="col-sm-3 col-form-label" >Data Group</label>
                      <div class="col-sm-9">
                        <div class="">
                          <treeselect :options="dataSourceGroupList" v-model="frmModel.dataSourceGroup" placeholder="Search..." @input="getData('outer')"/>
                        </div>
                      </div>
                  </div>
                  <template v-if="frmModel.dataSourceGroup && dataList.length > 0">
                    <div class="row m-0 mb-3">
                      <label for="" class="col-sm-3 col-form-label">Target Indicator</label >
                      <div class="col-sm-9">
                        <div class="">
                          <treeselect :options="dataList" v-model="frmModel.targetIndicator" placeholder="Search..." />
                        </div>
                      </div>
                    </div>
                    <template v-if="frmModel.targetIndicator">
                      <div class="row m-0 mb-3">
                        <label for="operand" class="col-sm-3 col-form-label" >Comparison Type</label >
                        <div class="col-sm-9">
                          <b-form-group class="pt-2 mb-0" v-slot="{ ariaDescribedby }">
                            <b-form-radio-group
                              id="comparisonType"
                              v-model="frmModel.comparisonType"
                              :aria-describedby="ariaDescribedby"
                              name="comparisonType-component"
                              >
                              <b-form-radio value="threshold">Threshold Value</b-form-radio>
                              <b-form-radio value="indicator">Indicator</b-form-radio>
                              <b-form-radio value="indicatorValue">Indicator with Value</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                      </div>
                      <transition name="slide-fade">
                        <div class="row m-0">
                          <div class="col-sm-3"></div>
                          <div class="col-sm-9">
                            <div class="border p-3">
                              <div class="row m-0 mb-3">
                                <label for="operand" class="col-sm-3 col-form-label" >Color</label >
                                <div class="col-sm-9">
                                  <div class="row mx-0">
                                    <div class="col-3 pl-0">
                                      <input type="color" class="form-control" v-model="frmModel.color"/>
                                    </div>
                                    <div class="col-9 pr-0">
                                      <input type="text" class="form-control" v-model="frmModel.color"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row m-0 mb-3">
                                <label for="operand" class="col-sm-3 col-form-label" >Operator</label >
                                <div class="col-sm-9">
                                  <div class="">
                                    <treeselect :options="operatorsList" v-model="frmModel.operator" placeholder="Search..." />
                                  </div>
                                </div>
                              </div>
                              <div class="row m-0 mb-3" v-if="frmModel.comparisonType === 'threshold'">
                                <label for="operand" class="col-sm-3 col-form-label" >Value</label >
                                <div class="col-sm-9">
                                  <div class="">
                                    <input type="number" class="form-control" v-model="frmModel.thresholdValue"/>
                                  </div>
                                </div>
                              </div>
                              <template  v-if="frmModel.comparisonType === 'indicator' || frmModel.comparisonType === 'indicatorValue'">
                                <div class="row m-0 mb-3">
                                  <label for="indicatorTypeName" class="col-sm-3 col-form-label" >Data Type</label>
                                    <div class="col-sm-9">
                                      <div class="">
                                        <treeselect :options="sourceList" v-model="frmModel.dataSourceInner" @input="getDataSourceGroup('inner')" placeholder="Search..." />
                                      </div>
                                    </div>
                                </div>
                                <template v-if="frmModel.dataSourceInner && dataSourceGroupListInner.length > 0">
                                  <div class="row m-0 mb-3">
                                    <label for="indicatorGroup" class="col-sm-3 col-form-label" >Data Group</label>
                                      <div class="col-sm-9">
                                        <div class="">
                                          <treeselect :options="dataSourceGroupListInner" v-model="frmModel.dataSourceGroupInner" placeholder="Search..." @input="getData('inner')"/>
                                        </div>
                                      </div>
                                  </div>
                                  <template v-if="frmModel.dataSourceGroupInner && dataListInner.length > 0">
                                    <div class="row m-0 mb-3">
                                      <label for="" class="col-sm-3 col-form-label">Indicator</label >
                                      <div class="col-sm-9">
                                        <div class="">
                                          <treeselect :options="dataListInner" v-model="frmModel.targetIndicatorInner" placeholder="Search..." />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row m-0 mb-3" v-if="frmModel.comparisonType === 'indicatorValue'">
                                      <label for="operand" class="col-sm-3 col-form-label" >Value</label >
                                      <div class="col-sm-9">
                                        <div class="">
                                          <input type="number" class="form-control" v-model="frmModel.thresholdValue"/>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                  <template v-if="frmModel.dataSourceGroupInner && dataListInner.length === 0 && isDataFetchedInner">
                                    <div class="row mx-0 mt-4">
                                      <div class="col-12 text-center">
                                        <h6 class="mb-0">No {{frmModel.dataSourceInner}} Found!</h6>
                                      </div>
                                    </div>
                                  </template>
                                </template>
                                <template v-if="frmModel.dataSourceInner && dataSourceGroupListInner.length === 0 && isDataFetchedInner">
                                  <div class="row mx-0 mt-4">
                                    <div class="col-12 text-center">
                                      <h6 class="mb-0">No Groups Found!</h6>
                                    </div>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </template>
                  </template>
                  <template v-if="frmModel.dataSourceGroup && dataList.length === 0 && isDataFetched">
                    <div class="row mx-0 mt-4">
                      <div class="col-12 text-center">
                        <h6 class="mb-0">No {{frmModel.dataSource}} Found!</h6>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-if="frmModel.dataSource && dataSourceGroupList.length === 0 && isDataFetched">
                  <div class="row mx-0 mt-4">
                    <div class="col-12 text-center">
                      <h6 class="mb-0">No Groups Found!</h6>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="bottomSubmitbtn float-right mb-4">
            <button class="btn btn-newprimary" @click="createUpdateAlert">
              {{isEdit ? "Update" : "Save" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ApiServices from "../service/ApiServices";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import swal from 'sweetalert2';
window.Swal = swal;

export default {
  components: {
    Treeselect
  },
  data() {
    return {
      outlierListLen:'',
      dataSourceGroupList: [],
      dataList: [],
      isDataFetched: false,
      originalDataSets: [],
      dataSourceGroupListInner: [],
      dataListInner: [],
      isDataFetchedInner: false,
      originalDataSetsInner: [],
      dSourceGroupList: [
        { "id": "[All metrics]", "label": "[All metrics]", "alias": "ALL" },
        { "id": "Reporting rates", "label": "Reporting rates", "alias": "REPORTING_RATE" },
        { "id": "Reporting rates on time", "label": "Reporting rates on time", "alias": "REPORTING_RATE_ON_TIME" },
        { "id": "Actual reports", "label": "Actual reports", "alias": "ACTUAL_REPORTS" },
        { "id": "Actual reporting rates on time", "label": "Actual reporting rates on time", "alias": "ACTUAL_REPORTS_ON_TIME" },
        { "id": "Expected reports", "label": "Expected reports", "alias": "EXPECTED_REPORTS" }
      ],
      sourceList: [
        { "id": "Indicators", "label": "Indicators" },
        { "id": "Data Elements", "label": "Data Elements" },
        { "id": "Data Sets", "label": "Data Sets" },
        { "id": "Event Data Items", "label": "Event Data Items" },
        { "id": "Program Indicators", "label": "Program Indicators"}
      ],
      showAlertForm:false,
      userProfile: "",
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      operatorsList: [
        { "id": "===", "label": "Equal to" },
        { "id": "!==", "label": "Not equal to" },
        { "id": ">", "label": "Greater than" },
        { "id": ">=", "label": "Greater than or equal to" },
        { "id": "<", "label": "Less than" },
        { "id": "<=", "label": "Less than or equal to" }
      ],
      perPage: 10,
      currentPage: 1,
      options: [
        { value: "10", text: "10" },
        { value: "50", text: "50" },
        { value: "100", text: "100" },
        { value: "500", text: "500" }
      ],
      allAlertList:[],
      searchName: "",
      appId:null,
      frmModel:{
        "alertID": "",
        "alertName":"",
        "alertDesc":"",
        "dataSource": null,
        "dataSourceGroup": null,
        "targetIndicator": null,
        "targetIndicatorName": "",
        "comparisonType": "threshold",
        "thresholdValue": "",
        "operator":"===",
        "color": "#FF0000",
        "dataSourceInner": null,
        "dataSourceGroupInner": null,
        "targetIndicatorInner": null,
        "targetIndicatorInnerName": ""
      },
      isEdit: false,
    };
  },
  computed: {
    alertList() {
      let filteredApps=[];
      filteredApps = this.allAlertList.filter(b => b.alertName && b.alertName.toLowerCase().includes(this.searchName.toLowerCase()) || b.targetIndicatorName && b.targetIndicatorName.toLowerCase().includes(this.searchName.toLowerCase()));
      // console.log(filteredApps);
      this.outlierListLen = filteredApps.length;
      return filteredApps.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    }
  },
  watch:{
    "frmModel.comparisonType": function(newValue) {
      if(!this.isEdit) {
        if(newValue === 'threshold') {
          this.frmModel.dataSourceInner = null
          this.frmModel.dataSourceGroupInner = null
          this.frmModel.targetIndicatorInner = null
          this.frmModel.targetIndicatorInnerName = ""
        } else {
          this.frmModel.thresholdValue = ""
        }
      }
    }
  },
  methods: {
    getData(type) {
      let isDataFetched = "isDataFetched"
      let targetIndicator = "targetIndicator"
      let dataList = "dataList"
      let dataSource = "dataSource"
      let dataSourceGroup = "dataSourceGroup"
      let originalDataSets = "originalDataSets"

      if(type === 'inner') {
        isDataFetched = "isDataFetchedInner"
        targetIndicator = "targetIndicatorInner"
        dataList = "dataListInner"
        dataSource = "dataSourceInner"
        dataSourceGroup = "dataSourceGroupInner"
        originalDataSets = "originalDataSetsInner"
      }
      if(this.frmModel[dataSource] && this.frmModel[dataSourceGroup]) {
        this.$root.loading = true
        this[isDataFetched] = false
        if(!this.isEdit) {
          this.frmModel[targetIndicator] = null
        }
        this[dataList] = []
        if (this.frmModel[dataSource] === 'Data Sets') {
          if (this.frmModel[dataSourceGroup] === '[All metrics]') {
            this[dataList] = this[originalDataSets]
          } else {
            this[dataList] = this[originalDataSets].filter(d => d.dataSourceGroup === this.frmModel[dataSourceGroup])
          }
          this.$nextTick(() => {
            this.$root.loading = false
            this[isDataFetched] = true
          })
        } else {
          let indicators = ApiServices.getFilteredData(this.frmModel[dataSource], this.frmModel[dataSourceGroup]);
          indicators.then(response => {
            // console.log(response)
            if (this.frmModel[dataSource] === 'Indicators') {
              this[dataList] = response.data.indicators
            }
            if (this.frmModel[dataSource] === 'Data Elements') {
              this[dataList] = response.data.dataElements
            }

            if (this.frmModel[dataSource] === 'Event Data Items') {
              this[dataList] = response.data.programDataElements
            }
            if (this.frmModel[dataSource] === 'Program Indicators') {
              this[dataList] = response.data.programs[0].programIndicators
            }
            // console.log("key", dataList)
            // console.log("key", this[dataList])
            this.$nextTick(() => {
              this.$root.loading = false
              this[isDataFetched] = true
            })
          })
        }
      }
    },
    getDataSourceGroup(type) {
      let dataSourceGroup = "dataSourceGroup"
      let targetIndicator = "targetIndicator"
      let isDataFetched = "isDataFetched"
      let dataSourceGroupList = "dataSourceGroupList"
      let dataSource = "dataSource"
      let originalDataSets = "originalDataSets"
      let dataList = "dataList"

      if(type === 'inner') {
        dataSourceGroup = "dataSourceGroupInner"
        targetIndicator = "targetIndicatorInner"
        isDataFetched = "isDataFetchedInner"
        dataSourceGroupList = "dataSourceGroupListInner"
        dataSource = "dataSourceInner"
        originalDataSets = "originalDataSetsInner"
        dataList = "dataListInner"
      }
      if(this.frmModel[dataSource]) {
        this.$root.loading = true

        if(!this.isEdit) {
          this.frmModel[dataSourceGroup] = null
          this.frmModel[targetIndicator] = null
        }
        this[isDataFetched] = false
        this[dataSourceGroupList] = []
        let indicatorGroups = ApiServices.getDataSourceGroups(this.frmModel[dataSource]);
        indicatorGroups.then(response => {
          // console.log(response)
          if (this.frmModel[dataSource] === 'Indicators') {
            this[dataSourceGroupList] = response.data.indicatorGroups
          }
          if (this.frmModel[dataSource] === 'Data Elements') {
            this[dataSourceGroupList] = response.data.dataElementGroups
          }
          if (this.frmModel[dataSource] === 'Data Sets') {
            this[dataSourceGroupList] = this.dSourceGroupList
            this.frmModel[dataSourceGroup] = "Reporting rates"
            let originalDSets = []
            response.data.dataSets.forEach(d => {
              this.dSourceGroupList.forEach(ds => {
                if (ds.alias !== "ALL") {
                  originalDSets.push({
                    ...d,
                    id: d.id + "." + ds.alias,
                    label: d.label + " (" + ds.label + ")",
                    dataSourceGroup: ds.label
                  })
                }
              })
            })
            // console.log("originalDSets",originalDSets)
            this[originalDataSets] = originalDSets
            this[dataList] = originalDSets.filter(d => d.dataSourceGroup === "Reporting rates")
            // console.log("originalDSets",this[dataList])
          }
          if (this.frmModel[dataSource] === 'Event Data Items') {
            this[dataSourceGroupList] = response.data.programs
          }
          if (this.frmModel[dataSource] === 'Program Indicators') {
            this[dataSourceGroupList] = response.data.programs
          }
          this.$nextTick(() => {
            this.$root.loading = false
            this[isDataFetched] = true
          })
        })
      }
    },
    resetForm() {
      this.frmModel = {
        "alertID": "",
        "alertName":"",
        "alertDesc":"",
        "dataSource": null,
        "dataSourceGroup": null,
        "targetIndicator": null,
        "targetIndicatorName": "",
        "comparisonType": "threshold",
        "thresholdValue": "",
        "operator":"===",
        "color": "#FF0000",
        "dataSourceInner": null,
        "dataSourceGroupInner": null,
        "targetIndicatorInner": null,
        "targetIndicatorInnerName": ""
      }
    },
    showForm(alertData = "reset"){
      if(alertData === "reset"){
        // console.log("alertData",alertData)
        this.resetForm()
        this.isEdit = false
      } else {
        // console.log("alertData",alertData)
        this.frmModel = alertData
        this.$nextTick(() => {
          this.getData('outer')
          this.getDataSourceGroup('outer')
          if(alertData.comparisonType !== 'threshold') {
            this.getData('inner')
            this.getDataSourceGroup('inner')
          }
        })
      }
      this.$nextTick(() => {
        this.showAlertForm = true
      })
      this.$nextTick(() => {
        this.goTo('outlierAdd')
      })
    },
    goTo(refName) {
      let element = this.$refs[refName];
      console.log(element)
      if(element) {
        let top = element.offsetTop;
        console.log(top)

        window.scrollTo(0, top);
      }
    },
    deleteAlert(id){
      // console.log(this.allAlertList);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "Cancel",
      }).then((result) => {
        // console.log(result);
        if(result.value){
          let alertList = JSON.parse(JSON.stringify(this.allAlertList))

          var appId = this.appId;
          let key = `${appId}_alertRules`
          let allKeys = ApiServices.getAllKeys();
          allKeys.then(keys => {
            if (keys.data.includes(key)) {
              let data = alertList.filter(a => a.alertID !== id)
              let response = ApiServices.updateConfig(data,key)
              response.then(response => {
                // console.log("delete",response);
                this.showAlert("Alert deleted successfully!", "title", "success")
              });
              this.$nextTick(() => {
                this.allAlertList = data
              })
            } else {
              this.showAlert("Config file not found!", "text", "info")
            }
          }).catch(() => {
            this.showAlert("DataStore not found!", "text", "info")
          })
        }
      });
    },
    editAlert(id){
      let alertData = this.allAlertList.find(a => a.alertID === id)
      this.isEdit = true
      this.showForm(alertData)
    },
    randomString(length) {
      var result = '', chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
      return result;
    },
    showAlert(text, textTpe, alertType) {
      this.$swal.fire({
        [textTpe]: text,
        icon: alertType,
      })
      this.$root.loading = false
    },
    createUpdateAlert(){
      this.$root.loading = true
      let alertID = this.isEdit ? this.frmModel.alertID : this.randomString(16)
      let targetIndicatorName = this.dataList.find(d => d.id === this.frmModel.targetIndicator).label
      let targetIndicatorInnerName = this.frmModel.targetIndicatorInner ? this.dataListInner.find(d => d.id === this.frmModel.targetIndicatorInner).label : ""
      // console.log("alertID",alertID)
      // console.log("targetIndicatorName",targetIndicatorName)
      this.frmModel.alertID = alertID
      this.frmModel.targetIndicatorName = targetIndicatorName
      this.frmModel.targetIndicatorInnerName = targetIndicatorInnerName
      // console.log(this.frmModel)

      let appId = this.appId;
      let key = `${appId}_alertRules`
      let allKeys = ApiServices.getAllKeys();
      allKeys.then(keys => {
        let alertText = `Alert ${this.isEdit ? 'updated' : 'added'} successfully!`
        if (keys.data.includes(key)) {
          ApiServices.getSavedConfig(key).then(res => {
            let savedData = res.data
            if(this.isEdit) {
                let alertIndex = savedData.findIndex(s => s.alertID === alertID)
                savedData[alertIndex] = this.frmModel
            } else {
              savedData.push(this.frmModel)
            }
            // console.log("savedData",savedData)
            ApiServices.updateConfig(savedData,key).then(response => {
              // console.log("update",response);
              this.showAlert(alertText, "title", "success")
              this.showAlertForm = false;
              this.updateAlertList(this.frmModel)
            }).catch(() => {
              this.showAlert("Error in saving data to DataStore!", "text", "info")
            })
          }).catch(() => {
            this.showAlert("Error in fetching data from DataStore!", "text", "info")
          })
        } else {
          let data = [this.frmModel]
          let response = ApiServices.saveConfig(data,key)
          response.then(response => {
            // console.log("save",response);
            this.showAlert(alertText, "title", "success")
            this.showAlertForm = false;
            this.updateAlertList(this.frmModel)
          });
        }
      }).catch(() => {
        this.showAlert("DataStore not found!", "text", "info")
      })
    },
    updateAlertList(data) {
      if(this.isEdit) {
        let alertIndex = this.allAlertList.findIndex(a => a.alertID === data.alertID)
        this.allAlertList[alertIndex] = data
        this.isEdit = false
      } else {
        this.allAlertList.push(data)
      }
    },
    getAlertList(){
      this.$root.loading = true
      var appId = this.appId;
      let key = `${appId}_alertRules`
      let allKeys = ApiServices.getAllKeys();
      allKeys.then(keys => {
        if (keys.data.includes(key)) {
          let saveConfig = ApiServices.getSavedConfig(key);
          saveConfig.then(res => {
            // console.log("Alert list ", res.data);
            this.allAlertList = res.data
            this.$root.loading = false
          });
        } else {
          console.log("Config file not found!")
          this.$root.loading = false
        }
      }).catch(() => {
        console.log("DataStore not found!")
        this.$root.loading = false
      })
    },
  },
  mounted() {
    this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    if(sessionStorage.getItem('appId')) {
      this.appId = sessionStorage.getItem('appId')
    }
    this.getAlertList();
  }
}

</script>
<style scoped lang="scss">
  .mainWrap-bg {
    background-color: #f4f4f4 !important;
    background-image: none;
    /* background-size: cover;
    background-position: center; */
    min-height: 100vh;
    /* padding: 20px 40px; */
    padding: 10px 20px;
  }
  .maindivWrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80vh;
  }
  .form-control {
    background-color: transparent !important;
  }
  .tableCard {
    .table {
      thead {
        tr {
          background: #2e3f53;
        th {
          color: #fff;
        }
      }
    }
    }
  }
  .addIndicatorTypebtn {
    position: relative;
    text-align: left;
    font-weight: 200 !important;
    border-radius: 2px !important;
    font-size: 0.875rem;
  }
  .addIndicatorTypebtn:hover {
    position: relative;
    text-align: left;
    font-weight: 200 !important;
    border-radius: 2px !important;
    font-size: 0.875rem;
  }
  .addIndicatorTypebtn::after {
    position: absolute;
    right: 15px;
    top: 15px;
  }
  .multiSelectOption option {
    font-size: 0.875rem;
    background: #f5f5f5;
    padding: 10px 12px;
    margin-bottom: 1%;
    white-space: initial;
    min-height: 2.5em;
  }
  .swipTextWrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .checkValid {
    text-align: left;
    width: 100%;
    position: relative;
    bottom: -57px;
    font-weight: 600;
  }
  textarea {
    width: 100%;
    height: 200px !important;
  }
  .has-search .form-control {
    padding-left: 2.375rem;
  }
  .has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    // height: 2.375rem;
    // line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
  }
  select:-internal-list-box:focus option:checked:hover{
    background-color: -internal-light-dark(rgb(206, 206, 206), rgb(84, 84, 84)) !important;
    color: -internal-light-dark(rgb(16, 16, 16), rgb(255, 255, 255)) !important;
  }
  table tbody{
    border-radius: 0px 0px 10px 10px;
  }
  table tbody tr:last-child td:nth-last-child(1){
    border-radius: 0px 0px 10px 0px;
  }
  table tbody tr:last-child td:nth-last-child(4){
    border-radius: 0px 0px 0px 10px;
  }
  select {
    background-repeat: no-repeat;
    -webkit-appearance: none;
    -moz-appearance: none;
  }
</style>
